'use strict';

function rgba2hex (r, g, b, a) {
  var hexColor = 'dddddd';

  if (r < 256 && g < 256 && b < 256 && a <= 1) {
    r = r * a + 255 * (1 - a);
    g = g * a + 255 * (1 - a);
    b = b * a + 255 * (1 - a);
    hexColor = ((r << 16) | (g << 8) | b).toString(16);
  }

  return hexColor;
}

module.exports = rgba2hex;
